// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v5.0.2 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */

  
.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}
.datePicker {
  width: 100%;
  /* max-width: 100%; */
  height: 34.6px;
  /* background-color :  #f8f8f8; */
    border: 1px solid #c3c3c3;
    border-radius: 5px;

    font-family: Inter-Bold;
    font-size: 15px;
    /* font-weight: bold; */
    font-style: normal;
    /* line-height: 2; */
    letter-spacing: 0.1px;
    text-align: left;
    color: #a7a7a7;
    padding-left: 20px; 
}
.datePicker-mobile{
  width: 230px;
  height: 34.6px;
  border: 2px solid #c3c3c3;
  border-radius: 7px;
  font-family: Inter-Bold;
  font-size: 15px;
  font-style: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: black;
  /* padding-left: 20px  */
}
.form-control{
  width: 299px ;
  height: 36.5px;
  border-radius: 8.3px;
  background-color: "rgba(0, 0, 0, 0)";
  border-style: "solid";
  border-width: 2px;
  border-color: #dfdfdf ;
  font-family: Inter-Medium;
  font-size: 16px;
  /* line-height: 18px; */
  letter-spacing: 0.1;
  text-align: "left";
  color: black;
  padding-left: 17px
}

.page-link {
  position: relative;
  display: block;
  color: #c32b2c;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: #c32b2c;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: #c32b2c;
  background-color: #e9ecef;
  outline: 0;
  /* box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); */
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #c32b2c;
  border-color: #c32b2c;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/bootstrap.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;EAKE;;;AAGF;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,iCAAiC;IAC/B,yBAAyB;IACzB,kBAAkB;;IAElB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,qIAAqI;AACvI;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap v5.0.2 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n  \n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n.datePicker {\n  width: 100%;\n  /* max-width: 100%; */\n  height: 34.6px;\n  /* background-color :  #f8f8f8; */\n    border: 1px solid #c3c3c3;\n    border-radius: 5px;\n\n    font-family: Inter-Bold;\n    font-size: 15px;\n    /* font-weight: bold; */\n    font-style: normal;\n    /* line-height: 2; */\n    letter-spacing: 0.1px;\n    text-align: left;\n    color: #a7a7a7;\n    padding-left: 20px; \n}\n.datePicker-mobile{\n  width: 230px;\n  height: 34.6px;\n  border: 2px solid #c3c3c3;\n  border-radius: 7px;\n  font-family: Inter-Bold;\n  font-size: 15px;\n  font-style: normal;\n  letter-spacing: 0.1px;\n  text-align: left;\n  color: black;\n  /* padding-left: 20px  */\n}\n.form-control{\n  width: 299px ;\n  height: 36.5px;\n  border-radius: 8.3px;\n  background-color: \"rgba(0, 0, 0, 0)\";\n  border-style: \"solid\";\n  border-width: 2px;\n  border-color: #dfdfdf ;\n  font-family: Inter-Medium;\n  font-size: 16px;\n  /* line-height: 18px; */\n  letter-spacing: 0.1;\n  text-align: \"left\";\n  color: black;\n  padding-left: 17px\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #c32b2c;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: #c32b2c;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 3;\n  color: #c32b2c;\n  background-color: #e9ecef;\n  outline: 0;\n  /* box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); */\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #c32b2c;\n  border-color: #c32b2c;\n}\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.page-link {\n  padding: 0.375rem 0.75rem;\n}\n\n.page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
